import {
    ContraventionAuditEventEntityName,
    ContraventionAuditEventType,
} from '@EcamModel/model/ContraventionAuditEvent';
import { MappingValue } from '@pages/cameras/add-new';
import { BaseSelect } from '@pages/cameras/list';

export type ContraventionAuditEventSelection = BaseSelect & {
    GroupTextKey: ContraventionAuditEventEntityName;
};

export const verificationNotesEventLogType: Partial<Record<ContraventionAuditEventType, string>> = {
    [ContraventionAuditEventType.Created]: 'Created',
    [ContraventionAuditEventType.Updated]: 'Updated',
    [ContraventionAuditEventType.Deleted]: 'Deleted',
};

export const verificationEventLogType: Partial<Record<ContraventionAuditEventType, string>> = {
    [ContraventionAuditEventType.Approved]: 'Approved',
    [ContraventionAuditEventType.Cancelled]: 'Cancelled',
    [ContraventionAuditEventType.Audit]: 'Audit',
    [ContraventionAuditEventType.CameraPhotoVehicleUpdated]: 'Updated camera photo vehicle',
    [ContraventionAuditEventType.PotentialContraventionPhotoUpdated]: 'Updated potential contravention photo',
    [ContraventionAuditEventType.ChangeEvidence]: 'Change evidence',
    [ContraventionAuditEventType.ChangePlate]: 'Change plate',
    [ContraventionAuditEventType.LookUp]: 'Look up',
    [ContraventionAuditEventType.SyncPCNStella]: 'Sync PCN to Stella',
};

export const contraventionEventLogAuditEventEntityName: Record<
    ContraventionAuditEventEntityName,
    MappingValue<ContraventionAuditEventType>[]
> = {
    [ContraventionAuditEventEntityName.Verification]: [
        ContraventionAuditEventType.Approved,
        ContraventionAuditEventType.Cancelled,
        ContraventionAuditEventType.Audit,
        ContraventionAuditEventType.CameraPhotoVehicleUpdated,
        ContraventionAuditEventType.PotentialContraventionPhotoUpdated,
        ContraventionAuditEventType.ChangeEvidence,
        ContraventionAuditEventType.ChangePlate,
        ContraventionAuditEventType.LookUp,
        ContraventionAuditEventType.SyncPCNStella,
    ].map((eventType) => {
        const label = verificationEventLogType[eventType] ?? 'Unknown';
        return {
            key: eventType,
            label,
        };
    }),

    [ContraventionAuditEventEntityName.VerificationNotes]: [
        ContraventionAuditEventType.Created,
        ContraventionAuditEventType.Updated,
        ContraventionAuditEventType.Deleted,
        ContraventionAuditEventType.Read,
    ].map((eventType) => {
        const label = verificationNotesEventLogType[eventType] ?? 'Unknown';
        return {
            key: eventType,
            label,
        };
    }),

    [ContraventionAuditEventEntityName.PotentialContraventionSync]: [],
};

export const contraventionTypeEventLog: ContraventionAuditEventSelection[] = Object.keys(
    contraventionEventLogAuditEventEntityName
).flatMap((groupKey) => {
    const eventLogGroup: MappingValue<ContraventionAuditEventType>[] =
        contraventionEventLogAuditEventEntityName[groupKey as ContraventionAuditEventEntityName];

    return eventLogGroup
        .filter((gr) => gr.key !== ContraventionAuditEventType.Read)
        .map((item, index) => ({
            Id: index + 1,
            Name: item.label,
            Value: item.key,
            GroupTextKey: groupKey as ContraventionAuditEventEntityName,
        }));
});
